import { PaginatedList } from '@/api/models/common/paginatedList'
import { PtfBeneficiaireIntervenant } from '@/api/models/ptfBeneficiaire/Intervenant'
import { PtfBeneficiaireMeeting, PtfBeneficiaireMeetingUpdate } from '@/api/models/ptfBeneficiaire/Meeting'
import { PtfBeneficiaireMeetingGrouped } from '@/api/models/ptfBeneficiaire/MeetingGrouped'
import api from '@/libs/axios'

const baseUrl = "PlateformeBeneficiaireMeetings"

export default class PtfBeneficiaireMeetingsResource {

  public async listIntervenants(
    pagenumber?: number,
    pagesize?: number,
    search?: string
  ): Promise<PaginatedList<PtfBeneficiaireIntervenant>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append("PageNumber", pagenumber.toString());
    if (pagesize) params.append("PageSize", pagesize.toString());
    if (search && search.length) params.append("Search", search?.toString());

    const response = await api.get(`${baseUrl}/listIntervenants`, { params: params });
    
    return response.data;
  }

  public async listMeetingsByIntervenantId(
    intervenantId: string, 
    dateDebut: string, 
    dateFin: string
  ): Promise<PtfBeneficiaireMeetingGrouped[]> {
    const params = new URLSearchParams();

    if (dateDebut) params.append("DateDebut", dateDebut.toString());
    if (dateFin) params.append("DateFin", dateFin.toString());

    const response = await api.get(`${baseUrl}/listMeetings/${intervenantId}`, { params: params });

    return response.data;
  }

  public async getIntervenantById(intervenantId: string): Promise<PtfBeneficiaireIntervenant> {
    const response = await api.get(`${baseUrl}/getIntervenant/${intervenantId}`);
    
    return response.data;
  }

  public async cancelMeetings(meetingsIds: string[]): Promise<string> {
    const response = await api.put(`${baseUrl}/cancelMeetings`, meetingsIds);
    
    return response.data;
  }

  public async getSites(beneficiaireId: string): Promise<any[]> {
    const params = new URLSearchParams();
    params.append("beneficiaireId", beneficiaireId);

    const response = await api.get(`${baseUrl}/sites`, { params: params } );
    return response.data;
  }

  public async getIntervenants(siteId: string): Promise<any[]> {
    const response = await api.get(`${baseUrl}/sites/${siteId}/intervenants`);
    return response.data;
  }

  public async getTypesRDV(siteId: string, intervenantId: string): Promise<any[]> {
    const response = await api.get(`${baseUrl}/sites/${siteId}/intervenants/${intervenantId}/typesRdv`);
    return response.data;
  }

  public async getDisponibilites(
    siteId: string, 
    intervenantId: string, 
    typeRdvId: string,
    dateDebut: string,
    dateFin: string
  ): Promise<any[]> {
    const params = new URLSearchParams();
    params.append("dateDebut", dateDebut);
    params.append("dateFin", dateFin);

    const response = await api.get(
      `${baseUrl}/sites/${siteId}/intervenants/${intervenantId}/typesRdv/${typeRdvId}/disponibilites`,
      { params: params }
    );
    return response.data;
  }

  public async create(meetingData: any): Promise<string> {
    const response = await api.post(`${baseUrl}`, meetingData);
    return response.data;
  }

  public async createIndisponibilite(indisponibiliteData: any): Promise<string> {
    const response = await api.post(`${baseUrl}/indisponibilites`, indisponibiliteData);
    return response.data;
  }

  public async deleteMeeting(meetingId: string): Promise<string> {
    const response = await api.delete(`${baseUrl}/${meetingId}`);
    return response.data;
  }
}
